import Main from './subPages/main';
import PromotionsPages from './subPages/promotions';

const routes = [
  {
    path: '/:category/*',
    canUse: [],
    Component: Main,
  },
  {
    path: '/promotions/*',
    canUse: [],
    Component: PromotionsPages,
  },
];

export default routes;
